import httpClient, {ApplicationJson, POST, PUT, GET, DELETE} from '@/apis/base/httpclient.js';
import commonFn from '@/commons/commonFunction.js';

export default class BaseAPI {
  baseUrl = '';
  controllerName = '';
  apiName = '';

  // khởi tạo ApiUrl
  // created by NDQUAN 20/08/2019
  // API được khởi tạo dựa trên apiName
  initAPI() {
    if (this.apiName) {
      this.baseUrl = window._apis[this.apiName] + '/' + this.controllerName;
    }
  }

  // Build api url
  // CreatedBy NDQUAN 20/08/2019
  getAPIUrl() {
    // Khi base url chưa khởi tạo
    if (this.baseUrl == '') {
      this.initAPI();
    }

    // Nếu có truyền thêm argument thì nó khởi tạo thêm url
    if (arguments && arguments.length > 0) {
      return commonFn.combineUrl(this.baseUrl, ...arguments);
    }

    return this.baseUrl;
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async postAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
    return await httpClient.requestAsync(config, POST, isShowLoading, isCancelRequest, contenType);
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async putAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
    return await httpClient.requestAsync(config, PUT, isShowLoading, isCancelRequest, contenType);
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async getAsync(
    config,
    isShowLoading = false,
    isCancelRequest = true,
    contenType = ApplicationJson,
    isShowExpiredToken = true,
  ) {
    return await httpClient.requestAsync(config, GET, isShowLoading, isCancelRequest, contenType, isShowExpiredToken);
  }

  /**
   * config: AxiosRequestConfig
   * @param config: {
   * url?: string;
   * method?: string;
   * baseURL?: string;
   * transformRequest?: AxiosTransformer | AxiosTransformer[];
   * transformResponse?: AxiosTransformer | AxiosTransformer[];
   * headers?: any;
   * params?: any;
   * paramsSerializer?: (params: any) => string;
   * data?: any;
   * timeout?: number;
   * withCredentials?: boolean;
   * adapter?: AxiosAdapter;
   * auth?: AxiosBasicCredentials;
   * responseType?: string;
   * xsrfCookieName?: string;
   * xsrfHeaderName?: string;
   * onUploadProgress?: (progressEvent: any) => void;
   * onDownloadProgress?: (progressEvent: any) => void;
   * maxContentLength?: number;
   * validateStatus?: (status: number) => boolean;
   * maxRedirects?: number;
   * httpAgent?: any;
   * httpsAgent?: any;
   * proxy?: AxiosProxyConfig | false;
   * cancelToken?: CancelToken;
   * }
   * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
   * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
   * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
   */
  async deleteAsync(config, isShowLoading = false, isCancelRequest = true, contenType = ApplicationJson) {
    return await httpClient.requestAsync(config, DELETE, isShowLoading, isCancelRequest, contenType);
  }

  /**
   * Lấy dữ liệu danh sách
   */
  getList(payload) {
    const request = {
      url: this.getAPIUrl() + '/list',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  getListSummary(payload) {
    const request = {
      url: this.getAPIUrl() + '/list-summary',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách full
   */
  getFullList(payload) {
    const request = {
      url: this.getAPIUrl() + '/full',
      data: payload,
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách full
   */
  getFullListCache(payload) {
    const request = {
      url: this.getAPIUrl() + '/fullList',
      data: payload,
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách tree
   */
  getTree(payload) {
    const request = {
      url: this.getAPIUrl() + '/tree',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách theo ids, ids là chuỗi phân cách bởi dấu ,
   * HTHIEP 13.07.2022
   */
  getDataByIds(payload) {
    const request = {
      url: this.getAPIUrl() + '/ids',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getNew(payload) {
    const request = {
      url: this.getAPIUrl() + '/new',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  getAutoID(payload) {
    const request = {
      url: this.getAPIUrl() + '/getAutoID',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy bản ghi mặc định khi thêm mới
   */
  getEdit(payload) {
    const request = {
      url: [this.getAPIUrl(), 'edit', payload.id].join('/'),
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy bản ghi để khôi phục chứng từ sau xóa
   */
  getRestore(payload) {
    const request = {
      url: this.getAPIUrl() + '/restore',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Lấy bản ghi nhân bản
   */
  getDuplicate(payload) {
    const request = {
      url: this.getAPIUrl() + '/duplicate/' + payload.id,
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Thêm mới
   */
  insert(payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Thêm mới
   */
  insertMulti(payload) {
    const request = {
      url: this.getAPIUrl() + '/batch',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Cập nhật
   */
  update(payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Xóa
   */
  delete(payload) {
    const request = {
      url: this.getAPIUrl(),
      data: payload,
    };
    return httpClient.deleteAsync(request, true);
  }

  /**
   * Check phát sinh trước khi xóa
   */
  deleteArise(payload) {
    const request = {
      url: this.getAPIUrl() + '/DeleteArise',
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Xóa chứng từ liên quan
   * NXCHIEN 19.07.2022
   */
  deleteRelation(payload) {
    const request = {
      url: this.getAPIUrl() + '/DeleteRelation',
      data: payload,
    };
    return httpClient.deleteAsync(request, true);
  }

  /**
   * Thực hiện ghi sổ khi thực hiện chọn tất
   * HQMINH 01.04.2024
   */
  postMultiSelectedAll(payload) {
    const request = {
      url: this.getAPIUrl() + '/multi-selected-all',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }

  /**
   * Thực hiện bỏ ghi sổ khi thực hiện chọn tất
   * HQMINH 01.04.2024
   */
  unPostMultiSelectedAll(payload) {
    const request = {
      url: this.getAPIUrl() + '/multi-selected-all',
      data: payload,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Thực hiện xóa
   * HQMINH 01.04.2024
   */
  deleteMultiSelectedAll(payload) {
    const request = {
      url: this.getAPIUrl() + '/multi-selected-all',
      data: payload,
    };
    return httpClient.deleteAsync(request, true);
  }

  /**
   * Lấy dữ liệu combobox load paging
   */
  getComboboxPaging(payload) {
    const param = {...payload};

    // xử lý tham số trước khi request load dữ liệu
    commonFn.processComboboxParamRequest(param);

    const request = {
      url: this.getAPIUrl() + '/combobox',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy các chứng từ tham chiếu
   * HQMINH 14.06.2023
   */
  loadVoucherReference(payload) {
    const request = {
      url: this.getAPIUrl() + '/GetVoucherReference',
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy các chứng từ tham chiếu của nhiều chứng từ
   * nvthinh 10.05.2023
   */
  loadMultipleVoucherReference(payload) {
    const request = {
      url: this.getAPIUrl() + '/GetMultipleVoucherReference',
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy các chứng từ tham chiếu
   * HQMINH 14.06.2023
   */
  saveVoucherReference(payload) {
    const request = {
      url: this.getAPIUrl() + '/SaveVoucherReference',
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Kiểm tra chứng từ có sinh từ chuyển khoản kho bạc không
   * ntduong2 25.12.2023
   * @param {*} payload
   * @returns
   */
  checkCreateByDvc(payload) {
    const request = {
      url: this.getAPIUrl() + '/CheckCreateByDvc/' + payload.voucher_ref_id,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy chi tiết chứng từ preview
   * HQMINH 15.04.2024
   */
  getListDetail(payload) {
    let request = {
      url: this.getAPIUrl() + `/listDetailPreview`,
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Thêm mới hàng loạt
   * vqphong - 13/02/2025
   */
  multipleInsert(payload) {
    let request = {
      url: this.getAPIUrl() + `/multiple-insert`,
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * lấy dữ liệu phân trang
   * vqphong - 11/06/2025
   */
  getPagingList(payload) {
    let request = {
      url: this.getAPIUrl() + '/paging',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}
